import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceDesSeven() {
  return (
    <Container className="p-3">
      <Row style={{ justifyContent: 'center' }} >
        <Row className='mt-3'>
          <Col className='service_des_title'>Pancreas & Spleen Problems </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <p className='service_des_p'>
              Pancreatic and biliary surgeons treat problems of the digestive system. The digestive system, composed of the bile ducts, gallbladder, liver and pancreas, processes fats and vitamins and removes substances the body doesn't need.
            </p>
            <p> The pancreas is a long, flat gland that lies in the middle of the abdomen, just behind the stomach. It produces enzymes which break down food and drink. It also releases hormones to help regulate blood sugar levels and release insulin-a hormone that helps control sugar levels in the bloodstream. </p>
            <p> Pancreatitis is an inflammation of the pancreas. It is usually caused by gallstones or alcoholism. </p>
            <p> The pancreas consists of two types: exocrine and endocrine. The exocrine portion secretes digestive enzymes into the small intestine while the endocrine part produces hormones including insulin, glucagon and somatostatin. </p>
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_title'> Spleen Problems </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <p className='service_des_p'>
              There is a significant number of different causes of spleen rupture, including trauma, aneurysms, infections (such as tuberculosis, typhoid fever and bacterial sepsis), tumors, autoimmune diseases, and vascular diseases. The latter are usually related to underlying diseases or defects in the blood vessels leading to the spleen. In any case, the majority of cases of spleen rupture do not cause any symptoms and therefore are discovered only when the spleen becomes enlarged (10 cm or more). On physical examination, one will often see evidence of a previous abdominal trauma.
            </p>
            <p> A necropsia will reveal that the walls of the splenic vessels (the ”splenic arteries”) have widened and narrowed (stenotic) in about half of cases. The patient may also have a splenomegaly (enlargement of the spleen), although this is often difficult to detect. A splenectomy is indicated if the patient has an enlarged spleen that causes symptoms, a necropsy has shown that the spleen is heavily infiltrated by inflammatory cells and reactive fibrosis, or the spleen is otherwise severely damaged. </p>
          </Col>
          <p> All of these surgical procedures can be performed in a minimally invasive fashion, when appropriate, through the use of robotic or laparoscopic surgical techniques.</p>
        </Row>
      </Row>
    </Container>
  )
}

export default ServiceDesSeven